import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
  selector: 'app-success-dialog',
  templateUrl: './success-dialog.component.html',
  styleUrls: ['./success-dialog.component.scss']
})
export class SuccessDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: {
      isCreate: boolean;
      isCreateUpdate: boolean;
      isMessage: boolean;
      title: string;
      subTitle: string;
      
    },
    private dialog: MatDialog,
    private router: Router
  ) {}
  
   

  closeDialog() {
    this.dialog.closeAll();
  }
}
